var map = {
	"./ai/logoPagePhone.png": 398,
	"./computernaya-gramotnost/logoPagePhone.png": 399,
	"./ege-informatika/logoPagePhone.png": 400,
	"./frontend/logoPagePhone.png": 401,
	"./game-design/logoPagePhone.png": 402,
	"./graphic-design-pro/logoPagePhone.png": 403,
	"./graphic-design/logoPagePhone.png": 404,
	"./intensive/logoPagePhone.png": 405,
	"./osnovy-programmirovaniya/logoPagePhone.png": 406,
	"./predprinimatelstvo/logoPagePhone.png": 407,
	"./python/logoPagePhone.png": 408,
	"./scratch/logoPagePhone.png": 409,
	"./unity/logoPagePhone.png": 410,
	"./videoblogging/logoPagePhone.png": 411,
	"./web-razrabotka/logoPagePhone.png": 412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 758;